/*
 * sq-countdown.js — SQUADRIG Voltage deal countdown (§5.5).
 * Runs a setInterval every second — must never leak, never show a
 * negative number, and must fail silently (not throw) on a bad/missing
 * deadline. Tested live in a browser with a 5s-out deadline before ship.
 */
(function () {
  'use strict';

  function pad(n) {
    return n < 10 ? '0' + n : String(n);
  }

  function initDeal(deal) {
    var countdown = deal.querySelector('[data-sq-countdown]');
    var cta = deal.querySelector('[data-sq-countdown-cta]');
    if (!countdown) return;

    var deadlineStr = countdown.getAttribute('data-sq-deadline');
    var deadline = deadlineStr ? new Date(deadlineStr) : null;

    if (!deadline || isNaN(deadline.getTime())) {
      countdown.hidden = true;
      return;
    }

    var daysEl = countdown.querySelector('[data-sq-cd="days"]');
    var hoursEl = countdown.querySelector('[data-sq-cd="hours"]');
    var minEl = countdown.querySelector('[data-sq-cd="min"]');
    var secEl = countdown.querySelector('[data-sq-cd="sec"]');

    var timerId = null;

    function expire() {
      if (timerId) {
        clearInterval(timerId);
        timerId = null;
      }
      countdown.hidden = true;
      if (cta) {
        var expiredLabel = cta.getAttribute('data-sq-expired-label') || 'Offer ended';
        cta.textContent = expiredLabel;
        cta.setAttribute('aria-disabled', 'true');
        cta.classList.add('is-disabled');
        cta.removeAttribute('href');
      }
    }

    function tick() {
      var remaining = deadline.getTime() - Date.now();
      if (remaining <= 0) {
        expire();
        return;
      }

      var totalSeconds = Math.floor(remaining / 1000);
      var days = Math.floor(totalSeconds / 86400);
      var hours = Math.floor((totalSeconds % 86400) / 3600);
      var mins = Math.floor((totalSeconds % 3600) / 60);
      var secs = totalSeconds % 60;

      if (daysEl) daysEl.textContent = pad(days);
      if (hoursEl) hoursEl.textContent = pad(hours);
      if (minEl) minEl.textContent = pad(mins);
      if (secEl) secEl.textContent = pad(secs);
    }

    tick();
    timerId = setInterval(tick, 1000);
  }

  function init() {
    var deals = document.querySelectorAll('[data-sq-deal]');
    deals.forEach(initDeal);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
